import { Select } from '@/lib/Selects';
import { AudienceSyncTimeBasedSchedule } from '@/models/audiences';
import { ISelectItem } from '@/models/select';
import { format, setDate } from 'date-fns';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type AudienceSyncRepeatMonthdayProps = {
  scheduleConfiguration: AudienceSyncTimeBasedSchedule;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

export const AudienceSyncRepeatMonthday: FC<AudienceSyncRepeatMonthdayProps> = ({ scheduleConfiguration, setFieldValue }) => {
  const { t } = useTranslation('ALL');

  const seed = new Date();
  const days: ISelectItem[] = Array.from(Array(31).keys()).map((value) => ({
    id: value + 1,
    label: format(setDate(seed, value + 1), 'do'),
  }));
  const [day, setDay] = useState<ISelectItem>(scheduleConfiguration.dayOfMonth ? days[scheduleConfiguration.dayOfMonth - 1] : days[0]);

  useEffect(() => {
    if (day) {
      setFieldValue('scheduleConfiguration.dayOfMonth', day.id);
    }
  }, [day]);

  return (
    <div className='mb-8 flex flex-row items-center'>
      <span className='mr-4'>{t('onThe')}</span>
      <div className='mr-4 w-32'>
        <Select items={days} value={day} onChange={setDay} />
      </div>
    </div>
  );
};
